import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/app/organizations/$organizationId/quick-start/subtopics/$subtopicId'
)({
  component: RouteComponent,
})

// Layout route that just renders the child route
function RouteComponent() {
  return <Outlet />
}
